import React, {useState, useRef} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import UIInput from 'components/input/input';
import Button from 'components/buttons/';
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import { Tooltip } from "react-tooltip";
import StringUtil from "utils/StringUtil";
import DateUtil from "utils/DateUtil";
import CommonUtil from 'utils/CommonUtil';
import codeDataStore from "common/codedata/store/CodeDataStore";
import UIUtils from "utils/UIUtils";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import UIInputMask from "../../../../components/input/UIInputMask";
import UI from "../../../../components/UI";


function ContentsContainer() {
    const location = useLocation();
    const receivedData = (location.state as any)?.data;
    const history = useHistory();

    const [payReqNo, setPayReqNo] = useState(receivedData?.vPAY_REQ_NO);
    const [tskReqNo, setTskReqNo] = useState(receivedData?.vTSK_REQ_NO);
    const [tskReqModiSeq, setTskReqModiSeq] = useState(receivedData?.vTSK_REQ_MODI_SEQ);
    const [payReqDate, setPayReqDate] = useState('');
    const [payReqStsCd, setPayReqStsCd] = useState('');
    const [payReqStsNm, setPayReqStsNm] = useState('');
    const [subYn, setSubYn] = useState('');
    const [perfCorpCnt, setPerfCorpCnt] = useState(0);
    const [suppCorpCnt, setSuppCorpCnt] = useState(0);
    const [perfCorpAmt, setPerfCorpAmt] = useState(0);
    const [suppCorpAmt, setSuppCorpAmt] = useState(0);
    const [perfTotCnt, setPerfTotCnt] = useState(0);
    const [suppTotCnt, setSuppTotCnt] = useState(0);
    const [perfTotAmt, setPerfTotAmt] = useState(0);
    const [suppTotAmt, setSuppTotAmt] = useState(0);
    const [perfCorp, setPerfCorp] = useState('');
    const [forePayYn, setForePayYn] = useState('');
    const [totAmt, setTotAmt] = useState(0);
    const [beforeTotAmt, setBeforeTotAmt] = useState(0); // 지급신청 금액
    const [payComplDate, setPayComplDate] = useState('');
    const [funPurUseNo,setFunPurUseNo] = useState('');  // 기금사용용도 넘버
    const [bizKindCd1, setBizKindCd1] = useState('');   // 과제분야(대분류)
    const [bizKindNm1, setBizKindNm1] = useState('');   // 대분류명
    const [bizKindCd2, setBizKindCd2] = useState('');   // 과제분야(소분류)
    const [bizKindNm2, setBizKindNm2] = useState('');   // 소분류명
    const [reqAmt, setReqAmt] = useState(0);
    const [bizCd, setBizCd] = useState('');             // 사업분류코드
    const [bizNm, setBizNm] = useState('');
    const [fileId, setFileId] = useState('');

    // 지원/수행기업 지원금액/갯수 임시 저장 변수
    const [suppTmpCnt, setSuppTmpCnt] = useState(0);
    const [perfTmpCnt, setPerfTmpCnt] = useState(0);
    const [suppTmpAmt, setSuppTmpAmt] = useState(0);
    const [perfTmpAmt, setPerfTmpAmt] = useState(0);

    //밑에 담당자 정보
    const [corpNm,setCorpNm] = useState(''); //과제명
    const [bizNo,setBizNo] = useState(''); //사업자번호
    const [corpRegNo,setCorpRegNo] = useState(''); //사업자번호
    const [personNm,setPersonNm] = useState(''); //이름
    const [posiNm,setPosiNm] = useState(''); //직급
    const [deptNm,setDeptNm] = useState(''); //부서명
    const [emailAdres,setEmailAdres] = useState(''); //이메일
    const [ofcTelNo,setOfcTelNo] = useState(''); //전화번호
    const [REC6,setREC6] = useState<any>([]);
    const [personId, setPersonId] = useState('');

//                                                             지원기업            사업자등록번호     지원금액        대표자명           특수관계인여부              지급은행                지급계좌            예금주                수취인                                       유형코드         부가세포함여부
    //const [suppCorpList, setSuppCorpList] = useState<any[]>([{ SUPP_CORP_NM : '', SUPP_BIZ_NO : '', PAY_AMT : '', SUPP_CEO_NM : '', SPC_RELATE_PERSON_YN : '', SUPP_ACC_BANK_CD : '', SUPP_ACC_NO : '', SUPP_ACC_HOLDER : '', FIND_REF_NM: '', num : 0 , checked : false, SUPP_TP_CD: '', VAT_YN: '', SUPP_CORP_YN: '', PARTNER_CORP_YN: '', ERR_CD: '', ERR_MSG: '' }]);
    //const [perfCorpList, setPerfCorpList] = useState<any[]>([{ SUPP_CORP_NM : '', SUPP_BIZ_NO : '', PAY_AMT : '', SUPP_CEO_NM : '', SPC_RELATE_PERSON_YN : '', SUPP_ACC_BANK_CD : '', SUPP_ACC_NO : '', SUPP_ACC_HOLDER : '', FIND_REF_NM: '', num : 0 , checked : false, SUPP_TP_CD: '', VAT_YN: '', SUPP_CORP_YN: '', PARTNER_CORP_YN: '', ERR_CD: '', ERR_MSG: '' }]);

    const [suppCorpList, setSuppCorpList] = useState<any[]>([]);
    const [perfCorpList, setPerfCorpList] = useState<any[]>([]);

    const [nextNum,setNextNum] = useState(1); // suppCorpList 고유 key

    const [elecApprYn, setElecApprYn] = useState('');
    const [elec, setElec] = useState('');

    const [bankNm, setBankNm] = useState('');       // 은행명
    const [bankCd, setBankCd] = useState('');       // 은행코드
    var bankNmTmp = "";
    var bankCdTmp = "";

	const modal2120 = useToggleState({});
    const modal2122 = useToggleState({});
    const [modal2120IsOpen, setModal2120IsOpen] = useState(false);
    const [modal2122IsOpen, setModal2122IsOpen] = useState(false);
    const [perfCorpYn, setPerfCorpYn] = useState('');

    let sheetId = useRef<string>("");
    let sheetCols = useRef<any>([]);

    const [suppSave, setSuppSave] = useState(false);
    const [perfSave, setPerfSave] = useState(false);

    const [totalRowCnt,setTotalRowCnt] = useState(0);
    const [showRowCnt,setShowRowCnt] = useState(100); //기본 row count

    // 파일정보 선언
    const [aprfFileNm, setAprfFileNm] = useState('');
    const [prfFileNm, setPrfFileNm] = useState('');
    const [taxFileNm, setTaxFileNm] = useState('');

    // REQ - 신청서, PLAN - 계획서, 수행기관 사업자 등록증 - BIZ
    const [aprfFileValue] = useState(new TbComFile());
    const [prfFileValue] = useState(new TbComFile());
    const [taxFileValue] = useState(new TbComFile());
    const [etcFileValue] = useState(new TbComFile());

    const [fileValue_tmp] = useState(new TbComFile());
    const fileValue = React.useDeferredValue(fileValue_tmp);

    // 폼체크 여부
    const [formCheck,setFormCheck] = useState(false);

    const [uploadComp, setUploadComp] = useState(false);
    const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
    const [fileInfoListPop, setFileInfoListPop] = React.useState<any[]>([]);

    //파일업로드
    const [uploadId, setUploadId] = React.useState("");
    const [corpList, setCorpList] = React.useState<any[]>([]);



    //초기 데이터 설정
    let totalCnt:number = 0;
    let totalCntRight:number = 0;
    let defaultRowCnt = 100;
    let SheetData = {};
    let SheetData_supp = {};
    let SheetData_perf = {};

    let data_modal = {};
    let totalCnt_dev_modal;



    const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        var id = event.target.id;
        let item;
        if(id === 'rd-1-1') {
            setForePayYn('N');
            item = aprfFileValue.tbComFileMapngDetailList[0];
            
            if(item != undefined){
				
				setAprfFileNm('');
				
	            let fileInfos : {
	                FILE_DETAIL_ID:string | undefined;
	                ORGINL_FILE_NM:string | undefined;
	                STRE_FILE_NM:string | undefined;
	                FILE_SIZE:number | undefined;
	                STRE_PATH:string | undefined;
	                FILE_EXTSN:string | undefined;
	                FILE_GB:string | undefined;
	                FILE_STATUS:string | undefined;
	            }[] = [];
	            
	            let fileInfo : {
	                FILE_DETAIL_ID:string | undefined;
	                ORGINL_FILE_NM:string | undefined;
	                STRE_FILE_NM:string | undefined;
	                FILE_SIZE:number | undefined;
	                STRE_PATH:string | undefined;
	                FILE_EXTSN:string | undefined;
	                FILE_GB:string | undefined;
	                FILE_STATUS:string | undefined;
	            };
	            
	             // @ts-ignore
	            let uniqKey = item.fileDetailId;
	            // @ts-ignore
	            let orginlFileNm = item.orginlFileNm;
	            // @ts-ignore
	            let streFileNm = item.streFileNm;
	            // @ts-ignore
	            let fileSize = item.fileSize;
	            // @ts-ignore
	            let strePath = item.strePath;
	            // @ts-ignore
	            let fileExtsn = item.fileExtsn;
	
	            //파일등록 정보
	            fileInfo = {
	                FILE_DETAIL_ID:uniqKey,
	                ORGINL_FILE_NM:orginlFileNm,
	                STRE_FILE_NM:streFileNm,
	                FILE_SIZE:fileSize,
	                STRE_PATH: strePath,
	                FILE_EXTSN:fileExtsn,
	                FILE_GB:'APRF' ,
	                FILE_STATUS:"DEL"
	            }
	
	            fileInfos.push(fileInfo);
	            let newList = [...fileInfoListPop];
	            setFileInfoListPop(newList.concat(fileInfos));
           }
        } else if(id === 'rd-1-2'){
            setForePayYn('Y');
        }
    };

    codeDataStore.read("[BANK]",).then(() => {
        var codeData = codeDataStore.get("[BANK]");
        codeData = codeData.filter((v) => { return (v.code !== '019' && v.code !== '084' && v.code !== '080' && v.code !== '010') });
        for(var i=0; i<codeData.length; i++) {
            bankNmTmp += "|" + codeData[i].name;
            bankCdTmp += "|" + codeData[i].code;
        }

        setBankNm(bankNmTmp);
        setBankCd(bankCdTmp);

    });

    function dateToStr(dateText) {

        if(dateText == null) return '';

        if(/^(-?)[0-9]+$/.test(dateText)){
            dateText = Number(dateText);
        }
        let date = new Date(dateText);
        let week = new Array('일', '월', '화', '수', '목', '금', '토');


        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        let dayName = week[date.getDay()];

        return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
    }

    function dateLpad(num){
        if(num.toString().length == 1){
            num = "0"+num;
        }

        return num;
    }

    async function initCallPay() {

        let param = {
            PAY_REQ_NO : receivedData?.vPAY_REQ_NO.replaceAll('-', ''),
            TSK_REQ_NO : receivedData?.vTSK_REQ_NO,
            TSK_REQ_MODI_SEQ : receivedData?.vTSK_REQ_MODI_SEQ
        };

        const response:any = await CommonUtil.execute({
            url:"usr_2125",
            data: param,
            progressBar:true
        })
        .then((response: any) => {

            // 지급 현황
            setPayReqNo(response.PAY_REQ_NO);
            setPayReqDate(dateToStr(response.PAY_REQ_DATE));
            setPayReqStsCd(response.PAY_REQ_STS_CD);
            setPayReqStsNm(response.PAY_REQ_STS_NM);
            setSubYn(response.SUB_YN);
            setPerfTotCnt(response.PERF_CORP_CNT);
            setSuppTotCnt(response.SUPP_CORP_EA);
            setPerfTmpCnt(response.PERF_CORP_CNT)
            setSuppTmpCnt(response.SUPP_CORP_EA);
            if(response.PERF_CORP_AMT > 0) {
                setPerfTmpAmt(response.PERF_CORP_AMT.replaceAll(',', ''));
                setPerfTotAmt(response.PERF_CORP_AMT.replaceAll(',', ''));
            }
            if(response.SUPP_CORP_AMT > 0) {
                setSuppTmpAmt(response.SUPP_CORP_AMT.replaceAll(',', ''));
                setSuppTotAmt(response.SUPP_CORP_AMT.replaceAll(',', ''));
            }
            if(response.TOT_AMT > 0) {
                setTotAmt(response.TOT_AMT.replaceAll(',', ''));            // 지급신청 총액(변동가능)
                setBeforeTotAmt(response.TOT_AMT.replaceAll(',', ''));      // 지급신청 변경전 금액(변경된 지급신청 총액과 비교를 위한 변수)
            }
            if(response.REQ_AMT > 0){
                setReqAmt(response.REQ_AMT.replaceAll(',', ''));
            }
            setForePayYn(response.FORE_PAY_YN);
            setPayComplDate(dateToStr(response.PAY_COMPL_DATE));
            setFunPurUseNo(response.FUN_PUR_USE_NO);
            setBizKindNm1(response.BIZ_KIND_NM_1);              // 대분류
            setBizKindNm2(response.BIZ_KIND_NM_2);              // 소분류
            setBizCd(response.BIZ_CD);
            setElecApprYn(response.ELEC_APPR_YN);
            setPerfCorpYn(response.PERF_CORP_YN);
            setBizNm(response.BIZ_NM);
            setFileId(response.FILE_ID);

            setPersonId(response.PAY_REQ_USERID);
            setCorpNm(response.CORP_NM);
            setBizNo(response.BIZ_NO);
            setCorpRegNo(response.CORP_REG_NO);
            setPersonNm(response.PAY_REQ_USERNM);
            setPosiNm(response.POSI_NM);
            setDeptNm(response.DEPT_NM);
            setEmailAdres(response.EMAIL_ID);
            setOfcTelNo(response.OFC_TEL_NO);

            setTskReqNo(response.TSK_REQ_NO);
            setTskReqModiSeq(response.TSK_REQ_MODI_SEQ);

            console.log("tskReqNo " + tskReqNo);
            console.log("tskReqModiSeq " + tskReqModiSeq);

            const result = response;
            if(result.REC6.length != 0){
                setREC6(result.REC6);
            //     let info = result.REC6[0];
            //     setCorpNm(info.CORP_NM);
            //     setBizNo(info.BIZ_NO);
            //     setCorpRegNo(info.CORP_REG_NO);
            //     setPersonNm(info.PERSON_NM);
            //     // setPersonId(info.PERSON_ID);
            //     setPosiNm(info.POSI_NM);
            //     setDeptNm(info.DEPT_NM);
            //     setEmailAdres(info.EMAIL_ADRES);
            //     setOfcTelNo(info.OFC_TEL_NO);
            }

            setCorpList(result.REC7);

            // APRF - 지급 신청서 / PRF - 선지급요청서 / TAX - 세금 계산서
            aprfFileValue.setTbComFileMapngDetailList([]);
            prfFileValue.setTbComFileMapngDetailList([]);
            taxFileValue.setTbComFileMapngDetailList([]);
            etcFileValue.setTbComFileMapngDetailList([]);

            let fileList = response.FILE_INFO;

            for(let i = 0; i < fileList.length; i++){
                if(fileList[i].FILE_GB == 'APRF'){
                    let aprfFileInfo = fileList[i];

                    //파일등록 정보
                    const fileDetail = new TbComFileMapngDetail();
                    fileDetail.setDwldId(aprfFileInfo.DWLD_ID);
                    fileDetail.setFileDetailId(aprfFileInfo.FILE_DETAIL_ID);
                    fileDetail.setFilePolicy(aprfFileInfo.FILE_POLICY);
                    fileDetail.setFileRpstr(aprfFileInfo.FILE_RPSTR);
                    fileDetail.setStrePath(aprfFileInfo.STRE_PATH);
                    fileDetail.setStreFileNm(aprfFileInfo.STRE_FILE_NM);
                    fileDetail.setOrginlFileNm(aprfFileInfo.ORGINL_FILE_NM);
                    fileDetail.setFileExtsn(aprfFileInfo.FILE_EXTSN);
                    fileDetail.setFileSize(aprfFileInfo.FILE_SIZE);
                    fileDetail.setRegistPsnNm(aprfFileInfo.REGIST_PSN_NM);
                    fileDetail.setRegistDt(aprfFileInfo.REGIST_DT);
                    aprfFileValue.putTbComFileMapngDetailList(fileDetail);

                    setAprfFileNm(aprfFileInfo.ORGINL_FILE_NM);
                    console.log(aprfFileInfo.ORGINL_FILE_NM);

                }else if(fileList[i].FILE_GB == 'PRF'){
                    let prfFileInfo = fileList[i];

                    //파일등록 정보
                    const fileDetail = new TbComFileMapngDetail();
                    fileDetail.setDwldId(prfFileInfo.DWLD_ID);
                    fileDetail.setFileDetailId(prfFileInfo.FILE_DETAIL_ID);
                    fileDetail.setFilePolicy(prfFileInfo.FILE_POLICY);
                    fileDetail.setFileRpstr(prfFileInfo.FILE_RPSTR);
                    fileDetail.setStrePath(prfFileInfo.STRE_PATH);
                    fileDetail.setStreFileNm(prfFileInfo.STRE_FILE_NM);
                    fileDetail.setOrginlFileNm(prfFileInfo.ORGINL_FILE_NM);
                    fileDetail.setFileExtsn(prfFileInfo.FILE_EXTSN);
                    fileDetail.setFileSize(prfFileInfo.FILE_SIZE);
                    fileDetail.setRegistPsnNm(prfFileInfo.REGIST_PSN_NM);
                    fileDetail.setRegistDt(prfFileInfo.REGIST_DT);
                    prfFileValue.putTbComFileMapngDetailList(fileDetail);

                    setPrfFileNm(prfFileInfo.ORGINL_FILE_NM);

                }else if(fileList[i].FILE_GB == 'TAX'){
                    let taxFileInfo = fileList[i];

                    //파일등록 정보
                    const fileDetail = new TbComFileMapngDetail();
                    fileDetail.setDwldId(taxFileInfo.DWLD_ID);
                    fileDetail.setFileDetailId(taxFileInfo.FILE_DETAIL_ID);
                    fileDetail.setFilePolicy(taxFileInfo.FILE_POLICY);
                    fileDetail.setFileRpstr(taxFileInfo.FILE_RPSTR);
                    fileDetail.setStrePath(taxFileInfo.STRE_PATH);
                    fileDetail.setStreFileNm(taxFileInfo.STRE_FILE_NM);
                    fileDetail.setOrginlFileNm(taxFileInfo.ORGINL_FILE_NM);
                    fileDetail.setFileExtsn(taxFileInfo.FILE_EXTSN);
                    fileDetail.setFileSize(taxFileInfo.FILE_SIZE);
                    fileDetail.setRegistPsnNm(taxFileInfo.REGIST_PSN_NM);
                    fileDetail.setRegistDt(taxFileInfo.REGIST_DT);
                    taxFileValue.putTbComFileMapngDetailList(fileDetail);

                    setTaxFileNm(taxFileInfo.ORGINL_FILE_NM);
                } else {
                    let fileInfo = fileList[i];

                    //파일등록 정보
                    const fileDetail = new TbComFileMapngDetail();
                    fileDetail.setDwldId(fileInfo.DWLD_ID);
                    fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
                    fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
                    fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
                    fileDetail.setStrePath(fileInfo.STRE_PATH);
                    fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
                    fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
                    fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
                    fileDetail.setFileSize(fileInfo.FILE_SIZE);
                    fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
                    fileDetail.setRegistDt(fileInfo.REGIST_DT);
                    etcFileValue.putTbComFileMapngDetailList(fileDetail);

                }

            }


        }).catch((error) => {
            CommonUtil.showAxiosError(error);
            return;
        });


    }

    const manageSelect = (e) => {
        let selectManage = REC6.filter(a => a.PERSON_ID == e.target.value);

        if(selectManage.length != 0){
            let info = selectManage[0];
            setPersonId(info.PERSON_ID)
            setCorpNm(info.CORP_NM);
            setBizNo(info.BIZ_NO);
            setCorpRegNo(info.CORP_REG_NO);
            setPersonNm(info.PERSON_NM);
            setPosiNm(info.POSI_NM);
            setDeptNm(info.DEPT_NM);
            setEmailAdres(info.EMAIL_ADRES);
            setOfcTelNo(info.OFC_TEL_NO);
        }

    };

    const onFileUpload = () => {
        if(uploadId){
            window["RAONKUPLOAD"].Transfer(uploadId);
        }
        setFormCheck(true);
    }

    //파일업로드
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

    //파일업로드 완료
    const onUploadComplete = () => {
        let type = "";
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
        console.log(JSON.stringify(arrayNew));

        let fileInfos : {
            FILE_DETAIL_ID:string;
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
            FILE_GB:string;
            FILE_STATUS:string;
        }[] = [];

        let fileInfo : {
            FILE_DETAIL_ID:string;
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
            FILE_GB:string;
            FILE_STATUS:string;
        };

        //파일등록 정보
        arrayNew?.map((item, index) => {
            if(item.status =="complete"){
                fileInfo = {
                    FILE_DETAIL_ID:item.uniqKey,
                    ORGINL_FILE_NM:item.originalName,
                    STRE_FILE_NM:item.uploadName,
                    FILE_SIZE:item.size,
                    STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
                    FILE_EXTSN:item.extension,
                    FILE_GB: type,
                    FILE_STATUS:"ADD"
                }

                fileInfos.push(fileInfo);
            }

            console.log("fileInfos : "+JSON.stringify(fileInfos));
        })

        //파일등록 정보
        arrayDel?.forEach((item, index) => {
            fileInfo = {
                FILE_DETAIL_ID:item.uniqKey,
                ORGINL_FILE_NM:item.originalName,
                STRE_FILE_NM:item.uploadName,
                FILE_SIZE:item.size,
                STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
                FILE_EXTSN:item.extension,
                FILE_GB: type,
                FILE_STATUS:"DEL"
            }

            fileInfos.push(fileInfo);

        })

        setFileInfoList(fileInfos);
        // let newList = [...fileInfoListPop];
        // newList = newList.filter(a => a.FILE_GB != type)
        // setFileInfoListPop(newList.concat(fileInfos));


    }

    // init
    React.useEffect(() => {
        initCallPay();  // 지급신청정보
    },[])

    async function onClose(type) {
        if(type == '2120'){
            setSuppTmpCnt(suppTotCnt);      // 행 삭제하고 저장하지 않은채로 모달 닫았을 때 갯수 되돌리기
            setSuppTmpAmt(suppTotAmt);      // 행 삭제하고 저장하지 않은채로 모달 닫았을 때 총액 되돌리기
            setModal2120IsOpen(false);
            // @ts-ignore
            IBSheet.sheet.dispose();
        }else if(type == '2122'){
            setPerfTmpCnt(perfTotCnt);      // 행 삭제하고 저장하지 않은채로 모달 닫았을 때 갯수 되돌리기
            setPerfTmpAmt(perfTotAmt);      // 행 삭제하고 저장하지 않은채로 모달 닫았을 때 총액 되돌리기
            setModal2122IsOpen(false);
            // @ts-ignore
            IBSheet.sheet_modal.dispose();
        }
    }

    async function onAfterOpen(type) {
         if(type == '2120'){
             if(perfCorpYn != 'N') {                           // 수행기관 있으면 축소된 지원기업 헤더 출력
                sheetId.current = 'modal_2120_List';
                sheetCols.current = modal2122Cols_supp;
            } else {
                sheetId.current = 'modal_2120_List';
                sheetCols.current = modal2120Cols;
            }
             ib.create();
        } else if(type == '2122') {
            sheetId.current = 'modal_2122_List';
            sheetCols.current = modal2122Cols_perf;
             ib_modal.create();
        }

        return () => {
            // @ts-ignore
            IBSheet.disposeAll(true);
        }

    }

    /**
     * 파일업로드 팝업
     */
    const reqModal = (type) => {
        // APRF - 신청서 , PRF - 선지급 요청서 , TAX - 세금 계산서
        let title = '';
        if(type == 'PRF') {
            title = '지급신청서';
            if(prfFileNm != ''){
                UIUtils.alert('파일 삭제 후 진행해주세요').then();
                return;
            }
        } else if(type == 'APRF'){
            title = '선지급 요청서';
            if(aprfFileNm != ''){
                UIUtils.alert('파일 삭제 후 진행해주세요').then();
                return;
            }
        }

        UIUtils.openFileUploadPopup({
            title: title,
            buttonTitle: "등록",
            attrs: {
                MaxTotalFileCount: "1",
                ExtensionAllowOrLimit: "1",
            },
            valueChanged: async data => {
                console.log("fileId uploadId : "+ uploadId);
                // @ts-ignore
				if(data != undefined && data.tbComFileMapngDetailList.length != 0){
                    const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
                    const arrayNew = dataArray.newFile;
                    const arrayDel = dataArray.deleteFile;
                    console.log("arrayNew", JSON.stringify(arrayNew));

                    let fileInfos : {
                        FILE_DETAIL_ID:string | undefined;
                        ORGINL_FILE_NM:string | undefined;
                        STRE_FILE_NM:string | undefined;
                        FILE_SIZE:number | undefined;
                        STRE_PATH:string | undefined;
                        FILE_EXTSN:string | undefined;
                        FILE_GB:string | undefined;
                        FILE_STATUS:string | undefined;
                    }[] = [];

                    let fileInfo : {
                        FILE_DETAIL_ID:string | undefined;
                        ORGINL_FILE_NM:string | undefined;
                        STRE_FILE_NM:string | undefined;
                        FILE_SIZE:number | undefined;
                        STRE_PATH:string | undefined;
                        FILE_EXTSN:string | undefined;
                        FILE_GB:string | undefined;
                        FILE_STATUS:string | undefined;
                    };



                    // @ts-ignore
                    let item = data.tbComFileMapngDetailList[0];

                    // @ts-ignore
                    let uniqKey = item.uniqKey;
                    // @ts-ignore
                    let orginlFileNm = item.orginlFileNm;
                    // @ts-ignore
                    let streFileNm = item.streFileNm;
                    // @ts-ignore
                    let fileSize = item.fileSize;
                    // @ts-ignore
                    let strePath = item.strePath;
                    // @ts-ignore
                    let fileExtsn = item.fileExtsn;

                    //파일등록 정보
                    fileInfo = {
                        FILE_DETAIL_ID:uniqKey,
                        ORGINL_FILE_NM:orginlFileNm,
                        STRE_FILE_NM:streFileNm,
                        FILE_SIZE:fileSize,
                        STRE_PATH: strePath,
                        FILE_EXTSN:fileExtsn,
                        FILE_GB:type,
                        FILE_STATUS:"ADD"
                    }
                    if(type == 'APRF'){
                        // @ts-ignore
                        setAprfFileNm(orginlFileNm);
                    }else if(type == 'PRF'){
                        // @ts-ignore
                        setPrfFileNm(orginlFileNm);
                    }


                    fileInfos.push(fileInfo);
                    // console.log(fileInfoListPop);

                    if(fileInfoListPop.filter(a => a.FILE_GB == type)){
                        setFileInfoListPop(fileInfoListPop.concat(fileInfos));
                    }else{
                        let newList = [...fileInfoListPop];
                        newList = newList.filter(a => a.FILE_GB != type)
                        setFileInfoListPop(newList.concat(fileInfos));
                    }
                }


            }
        })

    }


    async function fileDelete(type){
        // @ts-ignore
        let item;
        if(type == 'PRF' && prfFileValue.tbComFileMapngDetailList.length != 0){
            item = prfFileValue.tbComFileMapngDetailList[0];
        }
        if(type == 'APRF' && aprfFileValue.tbComFileMapngDetailList.length != 0){
            item = aprfFileValue.tbComFileMapngDetailList[0];
        }

        // console.log(item);
        if(item == undefined && fileInfoListPop.filter(a => a.FILE_GB == type).length != 0){
            let newList = [...fileInfoListPop];
            newList = newList.filter(a => a.FILE_GB != type)
            setFileInfoListPop(newList);
            UIUtils.alert('삭제 되었습니다.').then();
            if(type == 'PRF'){
                // @ts-ignore
                setPrfFileNm('')
            }else if(type == 'APRF'){
                // @ts-ignore
                setAprfFileNm('')
            }
            return;
        }else if(item == undefined){
            UIUtils.alert('삭제 할 파일이 없습니다.').then();
            return;
        }

        if(await UIUtils.confirm('삭제하시겠습니까?')){

            if(type == 'PRF') setPrfFileNm('');
            if(type == 'APRF') setAprfFileNm('');

            let fileInfos : {
                FILE_DETAIL_ID:string | undefined;
                ORGINL_FILE_NM:string | undefined;
                STRE_FILE_NM:string | undefined;
                FILE_SIZE:number | undefined;
                STRE_PATH:string | undefined;
                FILE_EXTSN:string | undefined;
                FILE_GB:string | undefined;
                FILE_STATUS:string | undefined;
            }[] = [];

            let fileInfo : {
                FILE_DETAIL_ID:string | undefined;
                ORGINL_FILE_NM:string | undefined;
                STRE_FILE_NM:string | undefined;
                FILE_SIZE:number | undefined;
                STRE_PATH:string | undefined;
                FILE_EXTSN:string | undefined;
                FILE_GB:string | undefined;
                FILE_STATUS:string | undefined;
            };



            // @ts-ignore
            let uniqKey = item.fileDetailId;
            // @ts-ignore
            let orginlFileNm = item.orginlFileNm;
            // @ts-ignore
            let streFileNm = item.streFileNm;
            // @ts-ignore
            let fileSize = item.fileSize;
            // @ts-ignore
            let strePath = item.strePath;
            // @ts-ignore
            let fileExtsn = item.fileExtsn;

            //파일등록 정보
            fileInfo = {
                FILE_DETAIL_ID:uniqKey,
                ORGINL_FILE_NM:orginlFileNm,
                STRE_FILE_NM:streFileNm,
                FILE_SIZE:fileSize,
                STRE_PATH: strePath,
                FILE_EXTSN:fileExtsn,
                FILE_GB:type,
                FILE_STATUS:"DEL"
            }

            fileInfos.push(fileInfo);
            let newList = [...fileInfoListPop];
            setFileInfoListPop(newList.concat(fileInfos));
            UIUtils.alert('정상 처리 되었습니다 저장시 파일이 삭제 됩니다.').then();
        }

    }



    ///////////////// 그리드 /////////////////

    // 지원기업 수정 목록(수행기업 없는 경우)
    let modal2120Cols = [
        {"Header": ["선택", {"Value": "", "Align": "Center","Icon": "Check","HeaderCheck": 1, "IconAlign": "Center"} ],"Type": "Bool", "Name": "sCheckBox","Align": "Center","RelWidth": 0.7,"CanEdit": "1", "BoolIcon": 4},
        {"Header": ["기금지원내역","지원기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 1},
        {"Header": ["기금지원내역","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 1,"Align": "Center","CanEdit": 1},
        {"Header": ["기금지원내역","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 1.5,"Align": "Right","CanEdit": 1},
        {"Header": ["중소기업 지급 계좌","대표자명"],"Type": "Text","Name": "SUPP_CEO_NM","RelWidth": 1,"Align": "Center","CanEdit": 1},
        {"Header": ["중소기업 지급 계좌","협력사\n여부"],"Type": "Enum","Name": "PARTNER_CORP_YN","RelWidth": 1,"Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["중소기업 지급 계좌","중소기업\n여부"],"Type": "Enum","Name": "SUPP_CORP_YN","RelWidth": 1,"Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["중소기업 지급 계좌","특수관계인\n여부"],"Type": "Enum","Name": "SPC_RELATE_PERSON_YN","Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["중소기업 지급 계좌","지급은행"],"Type": "Enum","Name": "SUPP_ACC_BANK_CD","RelWidth": 1.5,"Align": "Center","CanEdit": 1,"Enum": bankNm,"EnumKeys": bankCd },
        {"Header": ["중소기업 지급 계좌","지급계좌"],"Type": "Text","Name": "SUPP_ACC_NO","RelWidth":1.5,"Align": "Center","CanEdit": 1},
        {"Header": ["중소기업 지급 계좌","예금주"],"Type": "Text","Name": "SUPP_ACC_HOLDER","RelWidth": 1,"Align": "Center","CanEdit": 1},
        {"Header": ["조회결과","수취인"],"Type": "Text","Name": "FIND_REF_NM","RelWidth": 1,"Align": "Center","CanEdit": 0},
        {"Header": ["조회결과","ERR_CD"],"Type": "Text","Name": "ERR_CD","RelWidth": 1,"Align": "Center","CanEdit": 0, "Visible": 0},
        {"Header": ["조회결과","ERR_MSG"],"Type": "Text","Name": "ERR_MSG","RelWidth": 1,"Align": "Center","CanEdit": 0, "Visible": 0},
    ];

    // 수행기업 수정 목록
    let modal2122Cols_perf = [
        {"Header": ["선택", {"Value": "", "Align": "Center","Icon": "Check","HeaderCheck": 1, "IconAlign": "Center"} ],"Type": "Bool", "Name": "sCheckBox","Align": "Center","RelWidth": 1,"CanEdit": "1", "BoolIcon": 4},
        {"Header": ["기금지원내역","수행기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 1},
        {"Header": ["기금지원내역","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": 1},
        {"Header": ["기금지원내역","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 2,"Align": "Right","CanEdit": 1},
        {"Header": ["수행기관 지급 계좌 정보","대표자명"],"Type": "Text","Name": "SUPP_CEO_NM","RelWidth": 2,"Align": "Center","CanEdit": 1},
        {"Header": ["수행기관 지급 계좌 정보","특수관계인\n여부"],"Type": "Enum","Name": "SPC_RELATE_PERSON_YN","Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["수행기관 지급 계좌 정보","지급은행"],"Type": "Enum","Name": "SUPP_ACC_BANK_CD","RelWidth": 1.5,"Align": "Center","CanEdit": 1,"Enum": bankNm,"EnumKeys": bankCd},
        {"Header": ["수행기관 지급 계좌 정보","지급계좌"],"Type": "Text","Name": "SUPP_ACC_NO","RelWidth":1.5,"Align": "Center","CanEdit": 1},
        {"Header": ["수행기관 지급 계좌 정보","예금주"],"Type": "Text","Name": "SUPP_ACC_HOLDER","RelWidth": 1.5,"Align": "Center","CanEdit": 1},
        {"Header": ["수행기관 지급 계좌 정보","부가세 포함 여부"],"Type": "Enum","Name": "VAT_YN","RelWidth": 1.5,"Align": "Center","CanEdit": 1, "Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["조회결과","수취인"],"Type": "Text","Name": "FIND_REF_NM","RelWidth": 1.5,"Align": "Center","CanEdit": 0},
        {"Header": ["조회결과","ERR_CD"],"Type": "Text","Name": "ERR_CD","RelWidth": 1,"Align": "Center","CanEdit": 0, "Visible": 0},
        {"Header": ["조회결과","ERR_MSG"],"Type": "Text","Name": "ERR_MSG","RelWidth": 1,"Align": "Center","CanEdit": 0, "Visible": 0},
    ];

    // 지원기업 수정 목록(수행기업 있는 경우)
    let modal2122Cols_supp = [
        {"Header": ["선택", {"Value": "", "Align": "Center","Icon": "Check","HeaderCheck": 1, "IconAlign": "Center"} ],"Type": "Bool", "Name": "sCheckBox","Align": "Center","RelWidth": 1,"CanEdit": 1, "BoolIcon": 4},
        {"Header": ["기금지원내역","지원기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 1},
        {"Header": ["기금지원내역","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": 1},
        {"Header": ["기금지원내역","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 2,"Align": "Right","CanEdit": 1},
        {"Header": ["기금지원내역","대표자명"],"Type": "Text","Name": "SUPP_CEO_NM","RelWidth": 1,"Align": "Center","CanEdit": 1},
        {"Header": ["기금지원내역","협력사\n여부"],"Type": "Enum","Name": "PARTNER_CORP_YN","RelWidth": 1,"Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["기금지원내역","중소기업\n여부"],"Type": "Enum","Name": "SUPP_CORP_YN","RelWidth": 1,"Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["기금지원내역","특수관계인\n여부"],"Type": "Enum","Name": "SPC_RELATE_PERSON_YN","Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
    ];



    //====== 그리드 공통 부 START
    var ib = ib||{};
    ib = {
        //시트 초기화 구문
        'init':{
            "Cfg": {
                "SearchMode": 1,
                "PageLength": 999,
                "AutoRowHeight": 1,
                "InfoRowConfig": "0",
                "Alternate":"0",
                "HeaderMerge": 6,
                "HeaderCheck": 1,
                "HeaderCheckMode": 0,
                "CanSort": 0,                 // 소팅옵션 off
                "ZIndex": 900,               // 팝업에서 enum 출력
                "ShowFilter": 1,             // 필터행 표시
                "dataMerge":1,
                // "Height": "auto",
                "MenuMaxHeight": 300        // Enum 콤보박스 사이즈 조절
            },
            "Cols": [
                {"Header": ["선택", {"Value": "", "Align": "Center","Icon": "Check","HeaderCheck": 1, "IconAlign": "Center"} ],"Type": "Bool", "Name": "sCheckBox","Align": "Center","RelWidth": 1,"CanEdit": "1", "BoolIcon": 4},
                {"Header": ["기금지원내역","지원기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 1},
                {"Header": ["기금지원내역","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": 1},
                {"Header": ["기금지원내역","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 2,"Align": "Right","CanEdit": 1},
            ],
        },
        //시트 이벤트
        'event':{
            onRenderFirstFinish:function (evtParam) {
                //헤더행과 필터행 강제 머지

                //지원기업 헤더행 머지
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "sCheckBox", sheet.getRowById("Filter"), "sCheckBox");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "PAY_AMT", sheet.getRowById("Filter"), "PAY_AMT");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_CEO_NM", sheet.getRowById("Filter"), "SUPP_CEO_NM");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "SPC_RELATE_PERSON_YN", sheet.getRowById("Filter"), "SPC_RELATE_PERSON_YN");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_BANK_CD", sheet.getRowById("Filter"), "SUPP_ACC_BANK_CD");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_NO", sheet.getRowById("Filter"), "SUPP_ACC_NO");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_HOLDER", sheet.getRowById("Filter"), "SUPP_ACC_HOLDER");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "FIND_REF_NM", sheet.getRowById("Filter"), "FIND_REF_NM");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_CORP_YN", sheet.getRowById("Filter"), "SUPP_CORP_YN");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "PARTNER_CORP_YN", sheet.getRowById("Filter"), "PARTNER_CORP_YN");

                //초기 데이터 로딩
                initSheet_modal_2120();
            },
            //시트 클릭시 이벤트 처리
            onAfterClick:function(evtParam){
                if(evtParam.col === 'FIND_REF_NM' ){
                    if ( evtParam.row.ERR_CD !== '0000'){
                        UIUtils.alert('['+ evtParam.row.ERR_CD + ']' + evtParam.row.ERR_MSG).then();
                        return;
                    }
                }
            },
            //시트가 렌더링된 후 발생되는 이벤트입니다. 발생시점은 아래와 같은 부분에서 발생합니다.
            onRenderFinish  :function(evtParam){


            },
            onBeforeDataLoad:function (evtParam) {
            },
            onAfterGotoPage:function (evtParam) {
            },
            onAfterChange : function(evtParam) {
                //@ts-ignore
                var rows = sheet.getDataRows();
                var sum = 0;
                for(var i=0; i<rows.length; i++){
                    sum += rows[i]["PAY_AMT"];
                }
                setSuppTmpAmt(sum);
	            if(evtParam.col !== 'sCheckBox' ){
    	            evtParam.sheet.setValue({row:evtParam.row, col:"FIND_REF_NM", val:"", render:1});
 				};       
            },
            onImportFinish:function(evtParam){          // 엑셀 임포트 이벤트
                let rows = evtParam.data;
                rows.forEach((v) => { v["PAY_AMT"] = Math.floor(Number(v["PAY_AMT"]))+'' });
                setSuppTmpCnt(evtParam.data.length);

                //@ts-ignore
                var sum = 0;
                for(var i=0; i<rows.length; i++){
                    sum += Number(rows[i]["PAY_AMT"]);
                }
                setSuppTmpAmt(sum);
            }
        },
        //시트객체 생성
        'create':function () {
            let options = this.init;
            options.Cols = sheetCols.current;
            //@ts-ignore
            options.Events = this.event;
            //@ts-ignore
            IBSheet.create({
                id: 'sheet', // 생성할 시트의 id
                el: sheetId.current, // 시트를 생성할 Dom 객체 및 id
                options: options, // 생성될 시트의 속성
                data: SheetData_supp // 생성될 시트의 정적데이터
            });

            // global 변수 선언
            //@ts-ignore
            window.currentPage = -1;
        },
        //엑셀 다운로드
        'exportData':function () {
        },
    }


    var ib_modal = ib_modal||{};
    ib_modal = {
        //시트 초기화 구문
        'init':{
            "Cfg": {
                "SearchMode": 1,
                "PageLength": 999,
                "AutoRowHeight": 1,
                "InfoRowConfig": "0",
                "Alternate":"0",
                "HeaderMerge": 6,
                "HeaderCheck": 1,
                "HeaderCheckMode": 0,
                "CanSort": 0,                // 소팅옵션 off
                "ZIndex": 900,               // 팝업에서 enum 출력
                "ShowFilter": 1,             // 필터행 표시
                "dataMerge":1,
                // "Height": "auto",
                "MenuMaxHeight": 300        // Enum 콤보박스 사이즈 조절
            },
            Def:{
                Row:{
                    //AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
                }
            },
            //틀고정 좌측 컬럼 설정
            "Cols": []

        },
        //시트 이벤트
        'event':{
            onRenderFirstFinish:function (evtParam) {
                //헤더행과 필터행 강제 머지
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "sCheckBox", sheet_modal.getRowById("Filter"), "sCheckBox");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "PAY_AMT", sheet_modal.getRowById("Filter"), "PAY_AMT");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "SUPP_CEO_NM", sheet_modal.getRowById("Filter"), "SUPP_CEO_NM");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "SPC_RELATE_PERSON_YN", sheet_modal.getRowById("Filter"), "SPC_RELATE_PERSON_YN");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "SUPP_ACC_BANK_CD", sheet_modal.getRowById("Filter"), "SUPP_ACC_BANK_CD");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "SUPP_ACC_NO", sheet_modal.getRowById("Filter"), "SUPP_ACC_NO");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "SUPP_ACC_HOLDER", sheet_modal.getRowById("Filter"), "SUPP_ACC_HOLDER");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "VAT_YN", sheet_modal.getRowById("Filter"), "VAT_YN");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "FIND_REF_NM", sheet_modal.getRowById("Filter"), "FIND_REF_NM");


                //초기 데이터 로딩
                initSheet_modal_2122();
            },
            //시트 더블클릭시 이벤트 처리
            onAfterClick:function(evtParam){
                if(evtParam.col === 'FIND_REF_NM' ){
                    if ( evtParam.row.ERR_CD !== '0000'){
                        UIUtils.alert('['+ evtParam.row.ERR_CD + ']' + evtParam.row.ERR_MSG).then();
                        return;
                    }
                }
            },
            //시트가 렌더링된 후 발생되는 이벤트입니다. 발생시점은 아래와 같은 부분에서 발생합니다.
            onRenderFinish  :function(evtParam){
            },
            onBeforeDataLoad:function (evtParam) {
            },
            onAfterGotoPage:function (evtParam) {
            },
            onAfterChange : function(evtParam) {
                // @ts-ignore
                var rows = sheet_modal.getDataRows();
                var sum = 0;
                for(var i=0; i<rows.length; i++){
                    sum += rows[i]["PAY_AMT"];
                }
                setPerfTotAmt(sum);
            },
            onImportFinish:function(evtParam){          // 엑셀 임포트 이벤트
                let rows = evtParam.data;
                rows.forEach((v) => { v["PAY_AMT"] = Math.floor(Number(v["PAY_AMT"]))+'' });
                //@ts-ignore
                var sum = 0;
                for(var i=0; i<rows.length; i++){
                    sum += Number(rows[i]["PAY_AMT"]);
                }
                setPerfTmpCnt(evtParam.data.length);
                setPerfTotAmt(sum);
                //@ts-ignore
                sheet_modal.rerender(1); //최종 수정된 내용을 화면에 반영한다.
            }
        },
        //시트객체 생성
        'create':function () {
            let options = this.init;
            options.Cols = sheetCols.current;

            //sheetId
            //@ts-ignore
            options.Events = this.event;
            //@ts-ignore
            IBSheet.create({
                id: 'sheet_modal', // 생성할 시트의 id
                el: sheetId.current, // 시트를 생성할 Dom 객체 및 id
                options: options, // 생성될 시트의 속성
                //data: this.data // 생성될 시트의 정적데이터
            });

            // global 변수 선언
            //@ts-ignore
            window.currentPage = -1;
        },
        //엑셀 다운로드
        'exportData':function () {

        },
        //조회 데이터
        'data':[]
    }

    //====== 그리드 공통 부  END

    //====== 그리드 데이터 가지고 오기  START

    async function initSheet_modal_2120() {

        let param = {};
        let url = '';

        param = {
            PAY_REQ_NO : payReqNo,
            SUPP_TP_CD : 'S'       // 지원기업('S')
        };

        //파라미터 전송
        const response:any = await CommonUtil.execute({
            url: 'usr_2116',
            data: param
        })

        //전체데이터
        let result = response.REC;
        SheetData_supp = response.REC;

        //전체ROW개수
        totalCnt = Object.keys(result).length;

        if(typeof result == 'undefined'){
           // alert('data is not loaded!!!')
            return;
        }

        // @ts-ignore
        sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함

        if(suppSave == true){
            // @ts-ignore
            sheet.loadSearchData(suppCorpList);
        } else {
            // @ts-ignore
            sheet.loadSearchData(SheetData_supp);
        }

    };

    async function initSheet_modal_2122() {

        let param = {};

        param = {
            PAY_REQ_NO : payReqNo,
            SUPP_TP_CD : 'P'        // 수행기업('P')
        };

        //파라미터 전송
        const response:any = await CommonUtil.execute({
            url: 'usr_2116',
            data: param
        })

        //전체데이터
        let result = response.REC;
        SheetData_perf = response.REC;

        //전체ROW개수
        totalCnt = Object.keys(result).length;

        if(typeof result == 'undefined'){
           // alert('data is not loaded!!!')
            return;
        }

        // @ts-ignore
        sheet_modal.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함

        if(perfSave == true){
            // @ts-ignore
            sheet_modal.loadSearchData(perfCorpList);
        }else {
            // @ts-ignore
            sheet_modal.loadSearchData(SheetData_perf);
        }

    };

    //====== 그리드 데이터 가지고 오기  END

    //행 추가
    async function addRow(type){

        if( type == '2120'){

            //@ts-ignore
            sheet.addRow({ visible: 1 });

            //전체 row visible 1 처리
            //@ts-ignore
            sheet.getDataRows().map(e => {
                e.Visible = 1;
                return e;
            })

            const suppNextList = suppCorpList.concat({
                SUPP_CORP_NM : '', SUPP_BIZ_NO : '', PAY_AMT : '', SUPP_CEO_NM : '', SPC_RELATE_PERSON_YN : '', SUPP_ACC_BANK_CD : '', SUPP_ACC_NO : '', FIND_REF_NM: '', num : 0 , checked : false, VAT_YN: '', SUPP_CORP_YN: '', PARTNER_CORP_YN: '', ERR_CD: '', ERR_MSG: ''
            });

            setSuppCorpList(suppNextList);
            //@ts-ignore
            setSuppTmpCnt(sheet.getDataRows().length);

            //@ts-ignore
            sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.

        } else if( type == '2122'){

            //@ts-ignore
            sheet_modal.addRow({ visible: 1 });

            //전체 row visible 1 처리
            //@ts-ignore
            sheet_modal.getDataRows().map(e => {
                e.Visible = 1;
                return e;
            })

            const perfNextList = perfCorpList.concat({
                SUPP_CORP_NM : '', SUPP_BIZ_NO : '', PAY_AMT : '', SUPP_CEO_NM : '', SPC_RELATE_PERSON_YN : '', SUPP_ACC_BANK_CD : '', SUPP_ACC_NO : '', FIND_REF_NM: '', num : 0 , checked : false, VAT_YN: '', SUPP_CORP_YN: '', PARTNER_CORP_YN: '', ERR_CD: '', ERR_MSG: ''
            });

            setPerfCorpList(perfNextList);
            //@ts-ignore
            setPerfTmpCnt(sheet_modal.getDataRows().length);

            //@ts-ignore
            sheet_modal.rerender(1); //최종 수정된 내용을 화면에 반영한다.

        }

    }

    // 행 삭제
    async function delRow (type) {

        let corpItems: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; }[] = [];
        // @ts-ignore
        let corpItem: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; } = {};
        let sum = 0;

        if(type == '2120'){

            //@ts-ignore
            var fRows = sheet.getDataRows().filter(x => x.sCheckBox === 1);

            //@ts-ignore
            sheet.removeRows(fRows);

            //@ts-ignore
            var rows = sheet.getDataRows();
            for(var i=0; i<rows.length; i++){
                // @ts-ignore
                corpItem = {
                    SUPP_CORP_NM: rows[i]["SUPP_CORP_NM"],
                    SUPP_BIZ_NO: rows[i]["SUPP_BIZ_NO"],
                    PAY_AMT: rows[i]["PAY_AMT"],
                    SUPP_CEO_NM: rows[i]["SUPP_CEO_NM"],
                    SPC_RELATE_PERSON_YN: rows[i]["SPC_RELATE_PERSON_YN"],
                    SUPP_ACC_BANK_CD: rows[i]["SUPP_ACC_BANK_CD"],
                    SUPP_ACC_NO: rows[i]["SUPP_ACC_NO"],
                    SUPP_ACC_HOLDER: rows[i]["SUPP_ACC_HOLDER"],
                    VAT_YN: rows[i]["VAT_YN"],
                    SUPP_CORP_YN: rows[i]["SUPP_CORP_YN"],
                    PARTNER_CORP_YN: rows[i]["PARTNER_CORP_YN"],
                    ERR_CD: rows[i]["ERR_CD"],
                    ERR_MSG: rows[i]["ERR_MSG"],
                    FIND_REF_NM: rows[i]["FIND_REF_NM"],
                }
                corpItems.push(corpItem);
                sum += rows[i]["PAY_AMT"];
            }
            setSuppTmpAmt(sum);
            setSuppTmpCnt(rows.length);

            // @ts-ignore
            sheet.loadSearchData(corpItems);

            //@ts-ignore
            sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.


        } else if(type == '2122'){

            //@ts-ignore
            var fRows = sheet_modal.getDataRows().filter(x => x.sCheckBox === 1);

            //@ts-ignore
            sheet_modal.removeRows(fRows);

            //@ts-ignore
            var rows = sheet_modal.getDataRows();
            for(var i=0; i<rows.length; i++){
                // @ts-ignore
                corpItem = {
                    SUPP_CORP_NM: rows[i]["SUPP_CORP_NM"],
                    SUPP_BIZ_NO: rows[i]["SUPP_BIZ_NO"],
                    PAY_AMT: rows[i]["PAY_AMT"],
                    SUPP_CEO_NM: rows[i]["SUPP_CEO_NM"],
                    SPC_RELATE_PERSON_YN: rows[i]["SPC_RELATE_PERSON_YN"],
                    SUPP_ACC_BANK_CD: rows[i]["SUPP_ACC_BANK_CD"],
                    SUPP_ACC_NO: rows[i]["SUPP_ACC_NO"],
                    SUPP_ACC_HOLDER: rows[i]["SUPP_ACC_HOLDER"],
                    VAT_YN: rows[i]["VAT_YN"],
                    SUPP_CORP_YN: rows[i]["SUPP_CORP_YN"],
                    PARTNER_CORP_YN: rows[i]["PARTNER_CORP_YN"],
                    ERR_CD: rows[i]["ERR_CD"],
                    ERR_MSG: rows[i]["ERR_MSG"],
                    FIND_REF_NM: rows[i]["FIND_REF_NM"],
                }
                corpItems.push(corpItem);
                sum += rows[i]["PAY_AMT"];
            }
            setPerfTmpAmt(sum);
            setPerfTmpCnt(rows.length);

            // @ts-ignore
            sheet_modal.loadSearchData(corpItems);

            //@ts-ignore
            sheet_modal.rerender(1); //최종 수정된 내용을 화면에 반영한다.

        }

    }


    // 지원/수행 기업 저장
    async function saveCorp(type) {

        let rows;

        if(type == '2120'){
            // @ts-ignore
            rows = sheet.getDataRows();
        } else if(type == '2122') {
            // @ts-ignore
            rows = sheet_modal.getDataRows();
        }
        // 행 입력 안하고 저장 시 return
        if(rows.length <= 0 ){
            UIUtils.alert('중소기업 지급 정보를 입력해주세요').then();
            return;
        }

        // 필수값 체크   *** 예금주조회로 이동 해야함***
        if(type == '2122') {
            for(var i=0; i<rows.length; i++) {
                if(rows[i]["SUPP_CORP_NM"] == "" || rows[i]["SUPP_BIZ_NO"] == "" || rows[i]["PAY_AMT"] == "" ||
                    rows[i]["SUPP_CEO_NM"] == "" || rows[i]["SPC_RELATE_PERSON_YN"] == "" || rows[i]["SUPP_ACC_BANK_CD"] == "" ||
                    rows[i]["SUPP_ACC_NO"] == "" || rows[i]["SUPP_ACC_HOLDER"] == "" || rows[i]["VAT_YN"] == ""
                ){
                    UIUtils.alert('중소기업 지급 정보를 입력해주세요').then();
                    return;
                } else if(rows[i]["SPC_RELATE_PERSON_YN"] == 'Y'){
                    UIUtils.alert('특수관계인 여부가 아니오 일때만 저장 가능합니다.').then();
                    return;
                } else if(rows[i]["FIND_REF_NM"] == undefined) {
                    UIUtils.alert('예금주 조회 후 저장버튼을 선택해주세요.').then();
                    return;
                } else if(rows[i]["FIND_REF_NM"] === "오류") {
                    UIUtils.alert('예금주조회에서 실패한 계좌정보는 삭제 후 다시 시도해 주세요.').then();
                    return;
                }
            }
        } else if(type == '2120'){
            if(perfCorpYn != 'N') {
                for(var i=0; i<rows.length; i++) {
                    if(rows[i]["SUPP_CORP_NM"] == "" || rows[i]["SUPP_BIZ_NO"] == "" || rows[i]["PAY_AMT"] == "" ||
                        rows[i]["SUPP_CEO_NM"] == "" || rows[i]["SPC_RELATE_PERSON_YN"] == "" || rows[i]["SUPP_CORP_YN"] == "" || rows[i]["PARTNER_CORP_YN"] == ""
                    ){
                        UIUtils.alert('중소기업 지급 정보를 입력해주세요').then();
                        return;
                    }else if(rows[i]["SPC_RELATE_PERSON_YN"] == 'Y'){
                        UIUtils.alert('특수관계인 여부가 아니오 일때만 저장 가능합니다.').then();
                        return;
                    }
                }
            } else {
                for(var i=0; i<rows.length; i++) {
					let typeNm = "";
                    if (rows[i]["SUPP_CORP_NM"] == "") {
						typeNm = "SUPP_CORP_NM";
	                }else if(rows[i]["SUPP_BIZ_NO"] == ""){
						typeNm = "SUPP_BIZ_NO";
					}else if(rows[i]["PAY_AMT"] == ""){
						typeNm = "PAY_AMT";
					}else if(rows[i]["SUPP_CEO_NM"] == ""){
						typeNm = "SUPP_CEO_NM";
					}else if(rows[i]["SPC_RELATE_PERSON_YN"] == ""){
						typeNm = "SPC_RELATE_PERSON_YN";
					}else if(rows[i]["SUPP_ACC_BANK_CD"] == ""){
						typeNm = "SUPP_ACC_BANK_CD";
					}else if(rows[i]["SUPP_ACC_NO"] == ""){
						typeNm = "SUPP_ACC_NO";
					}else if(rows[i]["SUPP_ACC_HOLDER"] == ""){
						typeNm = "SUPP_ACC_HOLDER";
					}else if(rows[i]["SUPP_CORP_YN"] == ""){
						typeNm = "SUPP_CORP_YN";
					}else if(rows[i]["PARTNER_CORP_YN"] == ""){
						typeNm = "PARTNER_CORP_YN";
					}else if(perfCorpYn == 'N' && rows[i]["SPC_RELATE_PERSON_YN"] == 'Y'){
                        UIUtils.alert('특수관계인 여부가 아니오 일때만 저장 가능합니다.').then();
                        return;
                    }else if(perfCorpYn == 'N' && (rows[i]["FIND_REF_NM"] == undefined || rows[i]["FIND_REF_NM"] == "")) {
                        UIUtils.alert('예금주 조회 후 저장버튼을 선택해주세요.').then();
                        return;
                    }else if(perfCorpYn == 'N' && rows[i]["FIND_REF_NM"] === "오류") {
                        UIUtils.alert('예금주조회에서 실패한 계좌정보는 삭제 후 다시 시도해 주세요.').then();
                        return;
                    }else if(perfCorpYn == 'N' && rows[i]["SUPP_CORP_YN"] == 'N') {
                        UIUtils.alert('중소기업여부가 예 일때만 저장 가능합니다..').then();
                        return;
                    }
                    
                     if(typeNm != ""){
						setTimeout(function(){
							// @ts-ignore
							sheet.focus(rows[i],typeNm);
						},10);
						
	                    UIUtils.alert('중소기업 지급 정보를 입력해주세요').then();
	                    return;
					}
                }
            }
        }

        // 중복 체크
        let arrBizNos: string[] = [];
        let bizNoDplctMsg = "";
        let chkMsg = "";
        
        let sum = 0;
        for(var i=0; i<rows.length; i++) {
            arrBizNos.push(StringUtil.replaceAll(rows[i]["SUPP_BIZ_NO"], "-", ""));
            sum += rows[i]["PAY_AMT"];
        }

        const rstbizNos: any = arrBizNos.reduce((accu, curr) => {
          accu.set(curr, (accu.get(curr) || 0) + 1);
          return accu;
        }, new Map());

        for (let [key, value] of rstbizNos.entries()) {
          if (value > 1) {
            bizNoDplctMsg += "사업자등록번호: " + key;
            bizNoDplctMsg += " (" + value + "건)\n";
          }
          
          // corpList에 존재하는지 확인
		  	
		  if (!corpList.some(corp => corp.BIZ_NO === key) && corpList.length > 0) {
			chkMsg += key+" ";
		  }
        }
		
		if (chkMsg !== "" && type == '2122') {
            UIUtils.alert("과제신청시 등록된 수행기관 사업자번호가 아닙니다 사업자번호:"+ chkMsg).then();
          return;
        }
       // if (bizNoDplctMsg !== "") {
       //     UIUtils.alert('중복되는 사업자등록번호가 존재합니다.').then();
       //   return;
       // }

        // if(Number(reqAmt) < Number(sum)) {
        //     UIUtils.alert("잔여 과제신청 금액이 부족합니다. 신청 가능 금액 : " + StringUtil.formatNumber(Number(reqAmt)) + "원 입니다").then();
        //     return;
        // }

        if((Number(reqAmt) + Number(beforeTotAmt)) < Number(sum)) {
            await UIUtils.alert("잔여 과제신청 금액이 부족합니다. 신청 가능 금액 : \n" + StringUtil.formatNumber((Number(reqAmt) + Number(beforeTotAmt))) + "원 입니다.").then();
            return;
        }

		
        // if(Number(sum) != Number(beforeTotAmt)){
        //     UIUtils.alert('지급신청 시 신청한 총 지급신청금액보다 작아야합니다.').then();
        //     return;
        // }

        let suppCorpItems: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; }[] = [];
        let perfCorpItems: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; }[] = [];
        // @ts-ignore
        let corpItem: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; } = {};

        // var sum = 0;

        for(var i=0; i<rows.length; i++) {
            corpItem = {
                SUPP_CORP_NM: rows[i]["SUPP_CORP_NM"],
                SUPP_BIZ_NO: rows[i]["SUPP_BIZ_NO"],
                PAY_AMT: rows[i]["PAY_AMT"],
                SUPP_CEO_NM: rows[i]["SUPP_CEO_NM"],
                SPC_RELATE_PERSON_YN: rows[i]["SPC_RELATE_PERSON_YN"],
                SUPP_ACC_BANK_CD: rows[i]["SUPP_ACC_BANK_CD"],
                SUPP_ACC_NO: rows[i]["SUPP_ACC_NO"],
                SUPP_ACC_HOLDER: rows[i]["SUPP_ACC_HOLDER"],
                FIND_REF_NM: rows[i]["FIND_REF_NM"],
                VAT_YN: rows[i]["VAT_YN"],
                SUPP_CORP_YN: rows[i]["SUPP_CORP_YN"],
                PARTNER_CORP_YN: rows[i]["PARTNER_CORP_YN"],
                ERR_CD: rows[i]["ERR_CD"],
                ERR_MSG: rows[i]["ERR_MSG"],
            }
        
            if(type == '2120') {
                suppCorpItems.push(corpItem);
            } else if(type == '2122'){
                perfCorpItems.push(corpItem);
            }
            
            // sum += rows[i]["PAY_AMT"];
        }

        if(type == '2120') {                    // 지원기업 저장
            setSuppSave(true);
            setSuppCorpList(suppCorpItems);
            setSuppTotCnt(rows.length);
            setSuppTmpCnt(rows.length);
            setSuppTmpAmt(sum);
            setSuppTotAmt(sum);
            setTotAmt(sum);
            setModal2120IsOpen(false);
            // @ts-ignore
            IBSheet.sheet.dispose();
        } else if(type == '2122'){              // 수행기업 저장
            setPerfSave(true);
            setPerfCorpList(perfCorpItems);
            setPerfTotCnt(rows.length);
            setPerfTmpCnt(rows.length);
            setPerfTmpAmt(sum);
            setPerfTotAmt(sum);
            setModal2122IsOpen(false);
            // @ts-ignore
            IBSheet.sheet_modal.dispose();
        }
        UIUtils.alert('저장되었습니다.').then();

    }


    // 지급신청 삭제
    async function deletePay() {

        let param = { PAY_REQ_NO: payReqNo };

        if(await UIUtils.confirm('삭제하시겠습니까?')){
            const response:any = await CommonUtil.execute({
                url: 'usr_2125_d001',
                data: param
            }).then((response:any) => {
                UIUtils.alert("삭제 되었습니다.")
                .then(() => {
                    history.push({
                        pathname: './usr_2123',
                        state: {data: receivedData}
                    });
                });
            }).catch(err => {
                CommonUtil.showAxiosError(err);
                return;
            });
        }

    }

    // 취소 - 지급신청상세 이동
    async function detailPay() {
        let vPAY_REQ_NO = payReqNo.replaceAll('-','');
        let dataToSend = {vPAY_REQ_NO, ...receivedData}
        //다른 페이지로 이동하면서 데이터 전달
        history.push({
            pathname: './usr_2125',
            state: {data: dataToSend}
        });

    }

    // 팝업 파일 업로드
    async function payFormCheck() {

        if(perfCorpYn === 'Y' && Number(totAmt) >= 0 && Number(perfTotAmt) <= 0){
            UIUtils.alert(<>수행기업 지급 정보를 입력해주세요</>).then();
            return;
        }

        if(Number(totAmt) <= 0 || Number(suppTotAmt) <= 0){
            UIUtils.alert(<>지원기업 지급 정보를 입력해주세요</>).then();
            return;
        }

        // if(Number(totAmt) != Number(beforeTotAmt)){
        //     UIUtils.alert('지급신청 시 신청한 총 지급신청금액보다 작아야합니다.').then();
        //     return;
        // }

        if(Number(perfTotAmt) > 0 ) {
            if (Number(suppTotAmt) !== Number(perfTotAmt)) {
                UIUtils.alert(<>지원금액합계와 지급금액합계금액을 동일하게 입력해 주세요.</>).then();
                return;
            }
        }
        //과제잔액(신청금액 - 토탈금액 또는 사용금액 ) 하고  < 지원금액 
        if((Number(reqAmt) + Number(beforeTotAmt)) < Number(suppTotAmt)) {
            await UIUtils.alert(<>잔여 과제신청 금액이 부족합니다. 신청 가능 금액 : <br/>" + StringUtil.formatNumber((Number(reqAmt) + Number(beforeTotAmt))) + "원 입니다.</>).then();
            return;
        }

        if(elecApprYn == 'N'){
            if(prfFileNm == ''){
                await UIUtils.alert(<>지급신청서가 누락되었습니다.<br/> 파일첨부 후 제출해 주세요.</>);
                return;
            }
        }

        if(forePayYn == 'Y' && aprfFileNm == ''){
            await UIUtils.alert(<>선지급 요청서가 누락되었습니다.<br/> 파일첨부 후 제출해 주세요.</>);
            return;
        }
        
        if(personNm == ''){
            await UIUtils.alert("담당자명을 입력해주세요.");
            return;
        }

        if(await UIUtils.confirm('저장하시겠습니까?')){
            setFormCheck(true);
            // 파일 업로드
            await onFileUpload();
        }

    }

    // 파일 업로드 성공여부 체크
    React.useEffect(() => {
        if(fileInfoList && formCheck) {
            let param = {
                PAY_REQ_NO: payReqNo,
                FORE_PAY_YN: forePayYn,
                TOT_AMT: totAmt,
                PAY_AMT: totAmt,
                BIZ_CD: bizCd,
                BIZ_NO: bizNo,
                FILE_INFO_LIST: fileInfoListPop.concat(fileInfoList),
                PAY_REQ_USER_ID : personId,
                PERSON_NM : personNm,
                POSI_NM: posiNm,                // 직급
                DEPT_NM: deptNm,                // 부서
                EMAIL_ADRES: emailAdres,           // 이메일
                OFC_TEL_NO: ofcTelNo,           // 전화번호
                SUPP_LIST: suppCorpList.length>=1?suppCorpList:null,        // 지원기업 리스트
                PERF_LIST: perfCorpList.length>=1?perfCorpList:null,        // 수행기업 리스트
                PERF_CORP: perfCorpYn,            // 수행기관
                FILE_ID: fileId,
                TSK_REQ_NO: tskReqNo,
                TSK_REQ_MODI_SEQ: tskReqModiSeq,
            };

            console.log("param : "+JSON.stringify(param));

            //내용 저장
            editPay(param);

        }
    }, [fileInfoList])



    // 수정사항 저장
    async function editPay(sendParam) {

        let vTSK_REQ_NO = tskReqNo.replaceAll('-', '');
        let vTSK_REQ_MODI_SEQ = tskReqModiSeq;
        let vPAY_REQ_NO = payReqNo.replaceAll('-', '');

        let dataToSend = {vTSK_REQ_NO, vTSK_REQ_MODI_SEQ, vPAY_REQ_NO, ...receivedData};
        
        const response:any = await CommonUtil.execute({
            url: 'usr_2129',
            data: sendParam
        }).then((response:any) => {
            UIUtils.alert("저장 되었습니다.").then(()=>{
                history.push({
                    pathname: './usr_2125',
                    state: {data: dataToSend}
                });
            });
           
        }).catch(err => {
            CommonUtil.showAxiosError(err);
            return;
        });

    }

 
    // 예금주 조회
    async function checkInq(type) {

        let rows:any;
        let tempRows:any;

        if(type == '2122') {
            // @ts-ignore
            rows = sheet_modal.getDataRows().filter(x => x.sCheckBox === 1);
            // @ts-ignore
            tempRows = sheet_modal.getDataRows().filter(x => x.sCheckBox !== 1);
            
            if (rows.length === 0) {
	            // @ts-ignore
	            rows = sheet_modal.getDataRows().filter(x => x.FIND_REF_NM === "오류" || x.FIND_REF_NM === undefined || x.FIND_REF_NM === "");
	            // @ts-ignore
	            tempRows =  sheet_modal.getDataRows().filter(x => x.FIND_REF_NM !== "오류" && x.FIND_REF_NM !== undefined && x.FIND_REF_NM !== "");
		    }
            
            for(var i=0; i<rows.length; i++) {
                if(rows[i]["SUPP_CORP_NM"] == "" || rows[i]["SUPP_BIZ_NO"] == "" || rows[i]["PAY_AMT"] == "" ||
                    rows[i]["SUPP_CEO_NM"] == "" || rows[i]["SPC_RELATE_PERSON_YN"] == "" || rows[i]["SUPP_ACC_BANK_CD"] == "" ||
                    rows[i]["SUPP_ACC_NO"] == "" || rows[i]["SUPP_ACC_HOLDER"] == "" || rows[i]["VAT_YN"] == ""
                ){
                    UIUtils.alert('중소기업 지급 정보를 입력해주세요').then();
                    return;
                }
            }
        } else if(type == '2120'){
            // @ts-ignore
            rows = sheet.getDataRows().filter(x => x.sCheckBox === 1);
            // @ts-ignore
            tempRows = sheet.getDataRows().filter(x => x.sCheckBox !== 1);
            
	        if (rows.length === 0) {
	            // @ts-ignore
	            rows = sheet.getDataRows().filter(x => x.FIND_REF_NM === "오류" || x.FIND_REF_NM === undefined || x.FIND_REF_NM === "");
	            // @ts-ignore
	            tempRows =  sheet.getDataRows().filter(x => x.FIND_REF_NM !== "오류" && x.FIND_REF_NM !== undefined && x.FIND_REF_NM !== "");
		    }
            
            if(perfCorpYn != 'N') {
                for(var i=0; i<rows.length; i++) {
                    if(rows[i]["SUPP_CORP_NM"] == "" || rows[i]["SUPP_BIZ_NO"] == "" || rows[i]["PAY_AMT"] == ""){
                        UIUtils.alert('중소기업 지급 정보를 입력해주세요').then();
                        return;
                    }
                }
            } else {
                for(var i=0; i<rows.length; i++) {
                    if(rows[i]["SUPP_CORP_NM"] == "" || rows[i]["SUPP_BIZ_NO"] == "" || rows[i]["PAY_AMT"] == "" ||
                        rows[i]["SUPP_CEO_NM"] == "" || rows[i]["SPC_RELATE_PERSON_YN"] == "" || rows[i]["SUPP_ACC_BANK_CD"] == "" ||
                        rows[i]["SUPP_ACC_NO"] == "" || rows[i]["SUPP_ACC_HOLDER"] == "" || rows[i]["SUPP_CORP_YN"] == "" || rows[i]["PARTNER_CORP_YN"] == ""
                    ){
                        UIUtils.alert('중소기업 지급 정보를 입력해주세요').then();
                        return;
                    }
                }
            }
        }
		
		
		
        let corpItems: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; }[] = [];
        // @ts-ignore
        let corpItem: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; } = {};

        for (var i = 0; i < rows.length; i++) {

            let suppBizNo = rows[i]["SUPP_BIZ_NO"].toString().replaceAll('-','');
            let suppAccNo = rows[i]["SUPP_ACC_NO"].toString().replaceAll('-','');

            // @ts-ignore
            corpItem = {
                SUPP_CORP_NM: rows[i]["SUPP_CORP_NM"],
                SUPP_BIZ_NO: suppBizNo,
                PAY_AMT: rows[i]["PAY_AMT"],
                SUPP_CEO_NM: rows[i]["SUPP_CEO_NM"],
                SPC_RELATE_PERSON_YN: rows[i]["SPC_RELATE_PERSON_YN"],
                SUPP_ACC_BANK_CD: rows[i]["SUPP_ACC_BANK_CD"],
                SUPP_ACC_NO: suppAccNo,
                SUPP_ACC_HOLDER: rows[i]["SUPP_ACC_HOLDER"],
                VAT_YN: rows[i]["VAT_YN"],
                SUPP_CORP_YN: rows[i]["SUPP_CORP_YN"],
                PARTNER_CORP_YN: rows[i]["PARTNER_CORP_YN"],
                ERR_CD: rows[i]["ERR_CD"],
                ERR_MSG: rows[i]["ERR_MSG"],
            }
            corpItems.push(corpItem);
        }

        let corpItemsTemp: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; }[] = [];
        // @ts-ignore
        let corpItemTemp: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; } = {};

        for (var i = 0; i < tempRows.length; i++) {

            let tempSuppBizNo = tempRows[i]["SUPP_BIZ_NO"].toString().replaceAll('-','');
            let tempSuppAccNo = tempRows[i]["SUPP_ACC_NO"].toString().replaceAll('-','');

            // @ts-ignore
            corpItemTemp = {
                SUPP_CORP_NM: tempRows[i]["SUPP_CORP_NM"],
                SUPP_BIZ_NO: tempSuppBizNo,
                PAY_AMT: tempRows[i]["PAY_AMT"],
                SUPP_CEO_NM: tempRows[i]["SUPP_CEO_NM"],
                SPC_RELATE_PERSON_YN: tempRows[i]["SPC_RELATE_PERSON_YN"],
                SUPP_ACC_BANK_CD: tempRows[i]["SUPP_ACC_BANK_CD"],
                SUPP_ACC_NO: tempSuppAccNo,
                SUPP_ACC_HOLDER: tempRows[i]["SUPP_ACC_HOLDER"],
                VAT_YN: tempRows[i]["VAT_YN"],
                SUPP_CORP_YN: tempRows[i]["SUPP_CORP_YN"],
                PARTNER_CORP_YN: tempRows[i]["PARTNER_CORP_YN"],
                ERR_CD: tempRows[i]["ERR_CD"],
                ERR_MSG: tempRows[i]["ERR_MSG"],
                FIND_REF_NM: tempRows[i]["FIND_REF_NM"],
            }
            corpItemsTemp.push(corpItemTemp);
        }


        let param = { LIST: corpItems };
        let tempParam = { LIST: corpItemsTemp };

        //파라미터 전송
        const response:any = await CommonUtil.execute({
            url:'usr_2117',
            data: param
        }).then((response:any) => {
           	const SheetData = response.REC;
           	let finalRows:any;
           	
           	if(tempRows.length == 0){
				 finalRows = SheetData;	   
	  	    }else{
				 finalRows = SheetData.concat(tempParam.LIST);				  
			}
            
			
            if(type == '2120'){
                // @ts-ignore
                sheet.loadSearchData(finalRows);
            } else {

                // @ts-ignore
                sheet_modal.loadSearchData(finalRows);
            }
        }).catch((error) => {
            CommonUtil.showAxiosError(error);
            return;
        });

    }


    // 지원기업(수행기업있는) 양식 다운로드
    const subjTemplateDownload = () => {
        console.log("subjTemplateDownload");
        let fileName = "";
        if(perfCorpYn != 'N'){
            fileName = "suppListTemplate2.xlsx"     // 지원기업 양식(축소버전)
        } else {
            fileName = "suppListTemplate1.xlsx"     // 지원기업 양식(풀버전)
        }
        CommonUtil.downloadTemplateFile(fileName, "지원기업내역(양식).xlsx");
    };

    // 지원기업 양식 업로드
    const subjTemplateUpload = () => {
        //@ts-ignore
        let rows = sheet.getDataRows();
        //@ts-ignore
        sheet.removeRows(rows);
        //@ts-ignore
        sheet.loadExcel({ mode: 'HeaderSkip' });
    }

    // 수행기업 양식 다운로드
    const subjTemplateDownload2 = () => {
        console.log("subjTemplateDownload2");
        CommonUtil.downloadTemplateFile("perfListTemplate.xlsx", "수행기업내역(양식).xlsx");
    };

    // 수행기업 양식 업로드
    const subjTemplateUpload2 = () => {
        //@ts-ignore
        let rows = sheet_modal.getDataRows();
        //@ts-ignore
        sheet_modal.removeRows(rows);
        //@ts-ignore
        sheet_modal.loadExcel({ mode: 'HeaderSkip' });
    }

/*    const prfTemplateDownload = () => {
        CommonUtil.downloadTemplateFile("PaymentApplicationForm.hwp", "지급신청서(양식).hwp");
    }
*/
    const prfTemplateDownload = () => {
        CommonUtil.downloadTemplateFile("PaymentApplicationFormNew.hwp", "양식_지급신청서.hwp");
    }

    const aprfTemplateDownload = () => {
        CommonUtil.downloadTemplateFile("AprfRequestForm2.hwp", "선지급요청서.hwp");
    }

    function getOzReportPay(){
        //bizNm⌋⌈•
        let payNmTitle = '⌈'+bizNm + '⌋ 지급 신청서'
        let payNmSubTitle = bizNm + ' 지원과제'

        let year = new Date().getFullYear();
        let month = new Date().getMonth()+1;
        let day = new Date().getDate();

        let reqYn = 'N';

        if(elecApprYn == 'Y' || prfFileValue.tbComFileMapngDetailList.length != 0){
            reqYn = 'Y';
        }

        let suppTpCd = '';
        if(perfCorpYn == 'Y'){  // 수행기관 있음 여부 -> 있으면 수행기관 리스트 출력 없으면 지원기업 리스트 출력
            suppTpCd = 'P';
        }else {
            suppTpCd = 'S';
        }


        UIUtils.openOZReportViewerPopup({
            title: "지급신청서",
            reportName: "pay_req",
            parameter: {
                "connection.pcount": "34",
                "connection.args1": "payNmTitle="+payNmTitle,
                "connection.args2": "payNmSubTitle="+payNmSubTitle,
                "connection.args3": "totAmt="+StringUtil.formatNumber(Number(totAmt)),
                "connection.args4": "year="+year+'년',
                "connection.args5": "month="+month+'월',
                "connection.args6": "day="+day+'일',
                "odi.odinames": "pay_req_suppList,pay_req",
                "odi.pay_req_suppList.pcount": "2",
                "odi.pay_req_suppList.args1": "pay_req_no=" + payReqNo.replaceAll('-',''),
                "odi.pay_req_suppList.args2": "supp_tp_cd=" + suppTpCd,
                "odi.pay_req.pcount": "1",
                "odi.pay_req.args1": "pay_req_no=" + payReqNo.replaceAll('-',''),
                "information.debug":"true", // 콘솔정보(Ctrl+Z) 표시 여부
                // "toolbar.first":"true", // 첫페이지 이동 아이콘 표시
                // "toolbar.last":"true", // 마지막페이지 이동 아이콘 표시

                "pdf.fontembedding":"true", // PDF 폰트포함 (글꼴 깨지는것 방지)
                "pdf.fontembedding_subset":"true", // 폰트의 서브셋을 저장할지 여부

                "export.format":"pdf", // 저장포맷
                "export.filename": "지급신청서" + ".pdf", // 파일명
                "export.mode":"silent", // 설정창 보여줄지 여부

                "viewer.pagedisplay":"continuous", // 페이지 표시 옵션
                "viewer.viewmode":"normal", // 보고서 보기 모드
                "viewer.zoom": "90"
            },
            onClose: () => {
                console.log("Report Viewer Close");
            }
        })
    }


	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={2} lnbIdx={3}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">지급 내용 수정</h1>
					<section className="fund-section">
						<h3 className="section-title mb15">신청 기본 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">지급신청번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={payReqNo} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">지급신청일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={payReqDate} placeholder={''} readOnly={true} />
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title hz-item mb15">지원금 지급 방식</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<div className="fo-key">
										<span>지원금 지급방식</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip9">도움말</button>
										<Tooltip 
											id="tooltip9"  
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">
												<h6 className="tooltip-title">하기 해당되는 상생협력기금 지급방식을 체크하고 관련 내용을 기입</h6>
												<ul className="list-group">
													<li>(일괄정산) 출연기업이 협력재단에 제출한 지급신청서 및 정산서류를 확인하여 1회 지원금 지급하여 종료하는 과제</li>
													<li>(분할정산) 2회 이상 지급이 필요한 과제 또는 선지급이 필요한 경우</li>
													<li>(선지급여부)  과제 내용에 따라 선지급 요청 가능, 최대 70%로 제한</li>
												</ul>
											</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap15">
											<label htmlFor="rd-1-1" className="ip-rd-label">
												<input name="rd-1" id="rd-1-1" className="ip-rd" type="radio" value='N' checked={forePayYn == 'N'} onChange={handleOptionChange}/>
												<span className="check"></span>
												<span className="txt">사후정산</span>
											</label>
											<label htmlFor="rd-1-2" className="ip-rd-label">
												<input name="rd-1" id="rd-1-2" className="ip-rd" type="radio" value='Y' checked={forePayYn == 'Y'} onChange={handleOptionChange}/>
												<span className="check"></span>
												<span className="txt">선지급</span>
											</label>
                                            {bizCd == '008' &&
                                                <div>
                                                    <span className="fc-pri">
                                                        민간자율기획사업으로 신청하시는 경우, <br/>선지급은 과제비용의 최대 70%까지 가능합니다.
                                                    </span>
                                                </div>
                                            }
										</div>
									</div>
								</div>
								<div className="fo-item">
									<div className="fo-key">
										<span>총 지급신청금액</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip8">도움말</button>
										<Tooltip 
											id="tooltip8"  
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">
												지원(중소)기업을 직·간접적으로 지원하는 전체 금액<br />
												(수행기관에 지급하는 경우, 수행기관에 지급되는 금액 포함)
											</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											<div className="tf-unit hz-item hz-fg">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(totAmt)) || "0"} placeholder={''} readOnly={true} />
												<span className="u">원</span>
											</div>
											<div className="hz-item tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(totAmt + "") ?
                                                                                                      StringUtil.numKorPattern(Number(totAmt)) + " 원" : "원"})</span></div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<h3 className="section-title hz-item">지원금 지원 기업</h3>
							<div className="hz-root hz-gap8">
                                { perfCorpYn != 'N' &&
								    <Button color='gray-o' size="sm" onClick={() => setModal2122IsOpen(true)}>수행기업 목록 수정</Button>
                                }
								<Button color='gray-o' size="sm" onClick={() => setModal2120IsOpen(true)}>지원기업 목록 수정</Button>
							</div>
						</div>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<div className="fo-key">
										<span>지원기업수</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip10">도움말</button>
										<Tooltip 
											id="tooltip10"  
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">수혜받는 중소기업 수를 기입</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5">
											<UIInput className={'tf tf-md ta-right w100p'} value={suppTotCnt} placeholder={''} readOnly={true} />
											<p className="tx-msg hz-item">개사</p>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<div className="fo-key">
										<span>중소기업 지원금액</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip12">도움말</button>
										<Tooltip 
											id="tooltip12"  
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">지원(중소)기업에 직접 지급되는 금액</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											<div className="tf-unit hz-item hz-fg">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(suppTotAmt)) || "0"} placeholder={''} readOnly={true} />
												<span className="u">원</span>
											</div>
											<div className="hz-item tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(suppTotAmt + "") ?
                                                                                                        StringUtil.numKorPattern(Number(suppTotAmt)) + " 원" : "원"})</span></div>
										</div>
									</div>
								</div>
                                {perfCorpYn != 'N' &&
								<div className="fo-item">
									<div className="fo-key">
										<span>수행기관 수</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip11">도움말</button>
										<Tooltip 
											id="tooltip11"  
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">수행기업 수를 기입</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5">
											<UIInput className={'tf tf-md ta-right w100p'} value={perfTotCnt} placeholder={''} readOnly={true} />
											<p className="tx-msg hz-item">개사</p>
										</div>
									</div>
								</div>
                                }
                                {perfCorpYn != 'N' &&
								<div className="fo-item">
									<div className="fo-key">
										<span>수행기관 지급금액</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip13">도움말</button>
										<Tooltip 
											id="tooltip13"  
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">수행기관이 있는경우, 수행기관에 지급되는 금액</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											<div className="tf-unit hz-item hz-fg">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(perfTotAmt)) || "0"} placeholder={''} readOnly={true} />
												<span className="u">원</span>
											</div>
											<div className="hz-item tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(perfTotAmt + "") ?
                                                                                                        StringUtil.numKorPattern(Number(perfTotAmt)) + " 원" : "원"})</span></div>
										</div>
									</div>
								</div>
                                }
							</div>
						</form>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<div className="hz-root hz-gap5">
								<h3 className="section-title">첨부파일</h3>
								<button type="button" className="button-tooltip" data-tooltip-id="tooltip7">도움말</button>
								<Tooltip 
									id="tooltip7"  
									disableStyleInjection={true}
									place={"bottom-start"}
									className="tooltip-conts"
								>
									<div className="msg">
										<h6 className="tooltip-title">과제 신청 시 첨부 서류</h6>
										<ul>
											<li>1. 운영규정 별지 제2호 동반성장 투자재원 과제신청서(과제요약서 포함)
												<ul className="list-group">
													<li>서면 : 지급신청서(서면) 클릭하여 지급신청서 출력 후 직인을 찍고 스캔하여 첨부문서에 등록하셔야 합니다.</li>
													<li>전자인증 : 기업용 공인인증서를 이용하여 지급신청서(전자인증) 을 클릭하여 인증이 완료 되면 됩니다. <br />별도 첨부 문서는 없습니다.</li>
												</ul>
											</li>
											<li>2. 세부사업계획서(완료심사의 경우, 사업완료보고서)</li>
											<li>3. 수행기관 사업자등록증(해당시)</li>
											<li>4. 기타 심사에 필요하다고 판단되는 경우, 추가 서류를 요청 드릴 수 있습니다.</li>
										</ul>
									</div>
								</Tooltip>
							</div>
							{/*<Button color='gray-o' size="sm">첨부파일수정</Button>*/}
						</div>
						<form className="fo fo-col2" name="" action="" method="">
                            <div className="inner">
                                {elecApprYn == 'N' &&
                                    <div className="fo-item fo-m-1-3 req">
                                        <p className="fo-key">지급 신청서</p>
                                        <div className="fo-value">
                                            <div className="fund-form-group">
                                                <div className="fund-form-items mr30">
                                                    <div className="hz-root hz-gap8 w100p">
                                                        <UIInput className={'tf tf-md hz-item grow'} value={prfFileNm}
                                                                 placeholder={'파일을 첨부해 주세요.'}/>
                                                        <div className="hz-root hz-gap8">
                                                            <Button color='pri-o2' size="md"
                                                                    onClick={() => reqModal('PRF')}>찾기</Button>
                                                            <Button color='gray-o' size="md"
                                                                    onClick={() => fileDelete('PRF')}>삭제</Button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <Button color='gray-o' size="md" onClick={prfTemplateDownload}>양식
                                                    다운로드</Button>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {/* 지급신청서 전자인증 제출 완료*/}
                                {elecApprYn == 'Y' &&
                                    <div className="fo-item fo-m-1-3 req">
                                        <p className="fo-key">지급신청서</p>
                                        <div className="fo-value">
                                            <div className="fund-form-group">
                                                <div className="fund-form-items">
                                                    <p className="tx-msg">전자인증이 완료되었습니다.</p>
                                                </div>
                                                {/*<Button color='pri-o' size="md" onClick={() => getOzReportPay()}>미리보기</Button>*/}
                                            </div>
                                        </div>
                                    </div>
                                }
                                {/*
                                {elecApprYn == 'N' && prfFileValue.tbComFileMapngDetailList.length != 0 &&
                                    <div className="fo-item fo-m-1-3">
                                        <p className="fo-key">지급신청서</p>
                                        <div className="fo-value">
                                            <div className="fund-form-group">
                                                <div className="fund-form-items">
                                                    <UI.FileDownloadSimpleMode value={prfFileValue}
                                                                               viewMode={"fund-download"}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                */}
                                {forePayYn == 'Y' &&
                                    <div className="fo-item fo-m-1-3 req">
                                        <p className="fo-key">선지급 요청서</p>
                                        <div className="fo-value">
                                            <div className="fund-form-group">
                                                <div className="fund-form-items mr30">
                                                    <div className="hz-root hz-gap8 w100p">
                                                        <UIInput className={'tf tf-md hz-item grow'} value={aprfFileNm}
                                                                 placeholder={'파일을 첨부해 주세요.'}/>
                                                        <div className="hz-root hz-gap8">
                                                            <Button color='pri-o2' size="md"
                                                                    onClick={() => reqModal('APRF')}>찾기</Button>
                                                            <Button color='gray-o' size="md"
                                                                    onClick={() => fileDelete('APRF')}>삭제</Button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <Button color='gray-o' size="md" onClick={aprfTemplateDownload}>양식
                                                    다운로드</Button>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {/*
                                {forePayYn == 'Y' && aprfFileValue.tbComFileMapngDetailList.length != 0 &&
                                    <div className="fo-item fo-m-1-3 req">
                                        <p className="fo-key">선지급 요청서</p>
                                        <div className="fo-value">
                                            <div className="fund-form-group">
                                                <div className="fund-form-items">
                                                    <UI.FileDownloadSimpleMode value={aprfFileValue}
                                                                               viewMode={"fund-download"}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                */}
                                <div className="fo-item fo-m-1-3">
                                    <div className='w100p'>
                                        <UI.FileUpload
                                            onCreationComplete={onCreationComplete}
                                            onUploadComplete={onUploadComplete}
                                            attrs={{
                                                ImgPreView: "99"
                                            }}
                                            value={etcFileValue}
                                        />
                                    </div>
                                </div>

                            </div>
                        </form>
                        <p className="tx-msg mb15"><span className="fc-pri">※ 항목 외 기타 파일들은 파일 첨부를 이용해 주세요.</span></p>

                    </section>
                    <section className="fund-section">
                        <h3 className="section-title mb15">기업 정보</h3>
                        <form className="fo fo-col2" name="" action="" method="">
                            <div className="inner">
                                <div className="fo-item">
                                    <p className="fo-key">기업명</p>
                                    <div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">법인사업자번호</p>
									<div className="fo-value">
                                        <UIInputMask
                                            mask={"999999-9999999"}
                                            className={'tf tf-md w100p'}
                                            value={corpRegNo}
                                            readOnly={true}
                                        />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업자번호</p>
									<div className="fo-value">
                                        <UIInputMask
                                            mask={"999-99-99999"}
                                            className={'tf tf-md w100p'}
                                            value={bizNo}
                                            readOnly={true}
                                        />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">담당자</p>
                                    <div className="fo-value">
  										<UIInput className={'tf tf-md w100p'} value={personNm} placeholder={''} valueChanged={(value) => setPersonNm(value)} />
                                    </div>
                                </div>
                                <div className="fo-item">
                                    <p className="fo-key">직급</p>
                                    <div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={posiNm} placeholder={''} valueChanged={(value) => setPosiNm(value)}/>
                                    </div>
                                </div>
                                <div className="fo-item">
                                    <p className="fo-key">부서</p>
                                    <div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={deptNm} placeholder={''} valueChanged={(value) => setDeptNm(value)}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">이메일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={emailAdres} placeholder={''} valueChanged={(value) => setEmailAdres(value)}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={ofcTelNo} placeholder={''} valueChanged={(value) => setOfcTelNo(value)}/>
									</div>
								</div>
							</div>
						</form>
					</section>
					<div className="hz-root hz-right hz-gap10 mt30">
						<Button color="gray-o" size="md"  onClick={() => deletePay()}>삭제</Button>
						<Button color="gray-o" size="md" onClick={() => detailPay()}>취소</Button>
						<Button color="pri" size="md" onClick={() => payFormCheck()}>저장</Button>
					</div>
				</main>
			</div>
			{/* modal - 지원 기업 목록 */}
			<ModalPopup
				open={modal2120IsOpen}
                title="지원기업 목록 수정"
                size="xlg"
                onClose={() => onClose('2120')}
                onAfterOpen={() => onAfterOpen('2120')}
			>
				<div className="modal-con">
					<div className="hz-root hz-right hz-gap10 mb15">
                        {perfCorpYn == 'N' &&
						    <Button color='pri' size="sm" onClick={() => checkInq('2120')} >예금주조회</Button>
                        }
						<Button color='pri-o' size="sm" onClick={() => addRow('2120')}>행추가</Button>
                        <Button color='gray-o' size="sm" onClick={() => delRow('2120')}>행삭제</Button>
                        <Button color='pri-o' size="sm"  onClick={subjTemplateDownload}>지원기업목록 양식받기</Button>
                        <Button color='gray-o' size="sm" onClick={subjTemplateUpload}>지원기업목록 Upload</Button>
					</div>
					<div className="tb-total mb15">
						<div className="tb-total-items">지원 금액 합계(원)</div>
						<div className="tb-total-items">
							<div className="fund-form-items tf-unit">
								<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(suppTmpAmt)) || "0"} placeholder={''}  readOnly={true}/>
								<span className="u">원</span>
							</div>
							<p className="tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(suppTmpAmt + "") ?
                                                                            StringUtil.numKorPattern(Number(suppTmpAmt)) + " 원" : "원"})</span></p>
						</div>
					</div>
					<div className="tb-top">
						<div>
							<p className="tx fc-black">총 <em className="fw500">{suppTmpCnt}</em>건</p>
						</div>
                        {/*
						<div className="hz-root hz-gap8">
							<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" value={showRowCnt}  onChange={(handleSelect)}>
                                    <option value="20">20개씩보기</option>
                                    <option value="50">50개씩보기</option>
                                    <option value="100">100개씩보기</option>
                                    <option value="200">200개씩보기</option>
                                    <option value="500">500개씩보기</option>
                                    <option value="1000">1000개씩보기</option>
								</select>
							</div>
						</div>
                        */}
					</div>
					<div className="ibsheet">
                        <div className="ibsheet" id="modal_2120_List" style={{height:"423px"}}>[D] IBSHEET 영역</div>
                    </div>
                    <p className="tx-msg mt10">※ [지원기업 목록]의 지원금액합계와 [수행금액 목록]의 지급금액합계가 일치하도록 작성하여 주시기 바랍니다.</p>
				</div> 
				<div className="modal-bottom">
					<Button color="gray-o" size="md" onClick={() => onClose('2120')}>취소</Button>
                    <Button color="pri" size="md" onClick={() => saveCorp('2120')}>저장</Button>
				</div>
			</ModalPopup>	
			{/* modal - 수행 기업 목록 */}
			<ModalPopup
				open={modal2122IsOpen}
                title="수행 기관 목록 수정"
                size="xlg"
                onClose={() => onClose('2122')}
                onAfterOpen={() => onAfterOpen('2122')}
			>
				<div className="modal-con">
					<div className="hz-root hz-right hz-gap10 mb15">
						<Button color='pri' size="sm" onClick={() => checkInq('2122')}>예금주조회</Button>
						<Button color='pri-o' size="sm" onClick={() => addRow('2122')}>행추가</Button>
                        <Button color='gray-o' size="sm" onClick={() => delRow('2122')}>행삭제</Button>
                        <Button color='pri-o' size="sm" onClick={subjTemplateDownload2}>수행기업목록 양식받기</Button>
                        <Button color='gray-o' size="sm" onClick={subjTemplateUpload2}>수행기업목록 Upload</Button>
					</div>
					<div className="tb-total mb15">
						<div className="tb-total-items">지원 금액 합계(원)</div>
						<div className="tb-total-items">
							<div className="fund-form-items tf-unit">
								 <UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(perfTmpAmt)) || "0"} placeholder={''}  readOnly={true}/>
                                 <span className="u">원</span>
							</div>
							<p className="tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(perfTmpAmt + "") ?
                                                                            StringUtil.numKorPattern(Number(perfTmpAmt)) + " 원" : "원"})</span></p>
						</div>
					</div>
					<div className="tb-top">
						<div>
							<p className="tx fc-black">총 <em className="fw500">{perfTmpCnt}</em>건</p>
						</div>
                        {/*
						<div className="hz-root hz-gap8">
							<div className="sl sl-sm w120">
								 <select name="showRowCnt" id="showRowCnt" value={showRowCnt}  onChange={(handleSelect)}>
                                    <option value="20">20개씩보기</option>
                                    <option value="50">50개씩보기</option>
                                    <option value="100">100개씩보기</option>
                                    <option value="200">200개씩보기</option>
                                    <option value="500">500개씩보기</option>
                                    <option value="1000">1000개씩보기</option>
								</select>
							</div>
						</div>
                        */}
					</div>
					<div className="ibsheet" id="modal_2122_List" style={{height:"423px"}}>[D] IBSHEET 영역</div>
                    <div id="pageNavi" className="pg"></div>
					<p className="tx-msg mt10">※ [지원기업 목록]의 지원금액합계와 [수행금액 목록]의 지급금액합계가 일치하도록 작성하여 주시기 바랍니다.</p>
				</div>
				<div className="modal-bottom">
					<Button color="gray-o" size="md" onClick={() => onClose('2122')}>취소</Button>
                    <Button color="pri" size="md" onClick={() => saveCorp('2122')}>저장</Button>
				</div>
			</ModalPopup>	
		</PageContainer>
	);
}
export default ContentsContainer;